// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606260833/js/" + chunkId + "." + {"44":"26b99edf","225":"0a53b24d","481":"1577cc42","486":"1527f5da","770":"d52c7b50"}[chunkId] + ".0.3660232522550877.chunk.js";
};